import { useOutletContext } from "react-router-dom";
import SettingsView from "../../components/adminDashboard/ui/settings/SettingsView.jsx";

export default function SystemSettings() {
  const {
    isAddingModel,
    setIsAddingModel,
    systemModels,
    newModelData,
    setNewModelData,
    handleAddModel,
    handleCancelAddModel,
  } = useOutletContext();
  return (
    <SettingsView
      isAddingModel={isAddingModel}
      setIsAddingModel={setIsAddingModel}
      systemModels={systemModels}
      newModelData={newModelData}
      setNewModelData={setNewModelData}
      onAddModel={handleAddModel}
      onCancelAddModel={handleCancelAddModel}
    />
  );
}
